import { HttpParams } from '@angular/common/http';

type ParamTypes = string | number | boolean | undefined;

/**
 * Builds the query params for an HTTP request, gracefully handling optional parameters.
 * 
 * For a given set of key-value pairs (where the values are potentially undefined),
 * returns a wrapped HttpParams object with all undefined values excluded.
 *
 * @export
 * @param {{ [paramName: string]: ParamTypes }} possiblyUndefinedParams
 * @return {*}  {{ params: HttpParams }} An HttpParams object wrapped into a valid {@link HttpClient.get} options object
 */
export function withParams(possiblyUndefinedParams: { [paramName: string]: ParamTypes }): { params: HttpParams } {
  // for the set of key-value pairs, we reduce them into a new HttpErrors object, but only add the ones that have a defined value
  const coalescedParams = Object.entries(possiblyUndefinedParams).reduce((collectedParams, [paramName, paramValue]: [string, ParamTypes]) => {
    return (paramValue != undefined) ? collectedParams.set(paramName, paramValue) : collectedParams;
  }, new HttpParams());

  return { params: coalescedParams };
}
